module.exports = __webpack_public_path__ + "static/media/FENGYUN 4A.2a7c3fe1.czml";